import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { SERVICES } from "../data/content";

export const Services = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="services" data-testid="advisory-services-section" className="bg-[#F8F9FA] py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <Reveal>
          <Eyebrow>Advisory Services</Eyebrow>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mt-6">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.12] text-[#0A0F1D] max-w-2xl">
              Five practices. One integrated point of view.
            </h2>
            <p className="text-slate-600 text-base max-w-md leading-relaxed">
              Engagements are scoped to the decision at hand — from a single board question to a
              full development-to-submission strategy.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid lg:grid-cols-6 gap-5" data-testid="services-grid">
          {SERVICES.map((s, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={s.num} delay={i * 0.07} className={s.span}>
                <button
                  data-testid={`service-card-${s.num}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className={`w-full h-full text-left border p-8 transition-[border-color,background-color,transform] duration-300 hover:-translate-y-1 ${
                    isOpen
                      ? "border-teal-600/50 bg-white shadow-[0_20px_60px_-30px_rgba(13,148,136,0.35)]"
                      : "border-slate-200 bg-white/60 hover:border-teal-600/40"
                  }`}
                >
                  <div className="flex items-start justify-between gap-4">
                    <span className="font-mono text-[11px] tracking-widest text-teal-700">{s.num}</span>
                    <span className={`w-7 h-7 flex items-center justify-center border transition-[border-color,transform] duration-300 ${
                      isOpen ? "border-teal-600/60 rotate-45" : "border-slate-300"
                    }`}>
                      <Plus className={`w-3.5 h-3.5 ${isOpen ? "text-teal-700" : "text-slate-500"}`} />
                    </span>
                  </div>
                  <h3 className="mt-6 font-serif text-2xl sm:text-[26px] leading-tight text-[#0B132B]">
                    {s.name}
                  </h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.summary}</p>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.ul
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                        data-testid={`service-items-${s.num}`}
                      >
                        <div className="pt-6 mt-6 border-t border-slate-200 grid sm:grid-cols-2 gap-x-6 gap-y-2.5">
                          {s.items.map((item) => (
                            <li key={item} className="list-none text-sm text-slate-700 flex gap-2.5">
                              <span className="text-teal-600">—</span>{item}
                            </li>
                          ))}
                        </div>
                      </motion.ul>
                    )}
                  </AnimatePresence>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
